import { render, staticRenderFns } from "./RunnitsLogoMarkSVG.vue?vue&type=template&id=1fb3ba66"
import script from "./RunnitsLogoMarkSVG.vue?vue&type=script&lang=ts"
export * from "./RunnitsLogoMarkSVG.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports